import React, { createContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getCategoryList, getERTPageDetails } from "../../api/Api";
import RouteConstants from "../../constants/routesContent.json";
import contentFile from "../../constants/contentFile.json";

export const ERTDetailContext = createContext({});
export const ERTDetailContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const previousPage = location?.state?.pageName;
  const previousScreen = location?.state?.previousPage;
  const ertListDetail = location?.state.getERTCategoryListData;
  const pageContent = contentFile.ertDetailPage;

  const [ertDetails, setErtDetails] = useState(ertListDetail);
  const [showModal, setShowModal] = useState(false);
  const [employeeTypeList, setEmployeeTypeList] = useState([]);
  const [toogleCheck, setToggleCheck] = useState(false);
  const [mainId, setMainId] = useState();
  const [status, setStatus] = useState("in");
  const [selectEmployeeType, setSelectEmployeeType] = useState({
    id: false,
    name: "Select Employee Type",
  });

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [statusCode, setStatusCode] = useState(0);
  const [spinner, setSpinner] = useState(false);

  const goBack = () => {
    navigate(-1);
  };
  // Logout function
  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };

  // function to close alert
  const handleAlertSubmit = () => {
    setShowAlert(false);
  };

  useEffect(() => {
    // get categroy list API
    CategoryList();
    // getting id fron location state
    const id = location?.state?.mainId;
    setMainId(Number(id));
  }, []);

  // Category list API function
  const CategoryList = async () => {
    try {
      const response = await getCategoryList();
      const list = response?.data?.data?.categories;
      setEmployeeTypeList(list);
    } catch (error) {
      console.log("error", error);
    }
  };

  // function to toggle button
  const onClickChangeStatus = () => {
    setToggleCheck(!toogleCheck);

    // status checking function
    if (toogleCheck === true) {
      setStatus("in");
    } else if (toogleCheck === false) {
      setStatus("out");
    }
  };

  // Ert filter API function
  const ertDetailsFilter = async (mainId, status, categoryId) => {
    try {
      setSpinner(true);
      const response = await getERTPageDetails(mainId, status, categoryId);
      if (response?.status === 200) {
        setSpinner(false);
        const details = response?.data?.data;
        setErtDetails(details);
        setShowModal(false);
        setSelectEmployeeType({
          id: false,
          name: "Select Employee Type",
        });
      }
    } catch (error) {
      setSpinner(false);
      setStatusCode(error?.response?.data?.status);
      if (
        error.response.data.status === 400 ||
        error.response.data.status === 401 ||
        error.response.data.status === 403
      ) {
        setShowModal(false);
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowModal(false);
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };

  // fuunction to show modal
  const onClickShowModal = () => {
    setShowModal(true);
  };

  // fuunction to close modal
  const handleClose = () => {
    setShowModal(false);
    setSelectEmployeeType({
      id: false,
      name: "Select Employee Type",
    });
  };

  const providerValue = {
    goBack,
    previousPage,
    previousScreen,
    pageContent, // Page content

    showModal, // state for modal
    onClickShowModal, // filter click modal showing function
    handleClose, // function to close modal
    employeeTypeList, // list of employee type
    selectEmployeeType, // state of selected list item
    setSelectEmployeeType, // set state of selected list item
    toogleCheck, // Present - absent status toggle state
    onClickChangeStatus, // function to toggle button
    ertDetailsFilter, // filter submit function
    mainId, // id passing to API
    status, // Present - absent status state
    ertDetails, // table list - data
    showAlert, // error alert pop state
    setShowAlert, // error alert pop set-state
    alertMessage, // alert message state
    logout, // logout function (logout when session expire)
    statusCode, // state for status code
    handleAlertSubmit, // function to close alert
    spinner, // state for spinner
  };
  return (
    <ERTDetailContext.Provider value={providerValue}>
      {children}
    </ERTDetailContext.Provider>
  );
};
